<template>
  <Calendar
    @change="fetchData"
    :exams="examsFiltered"
    :holidays="holidays"
    name="schoolClassExams"
    :allowedViews="['term']"
    :loading="loading"
  >
    <v-switch inset hideDetails v-model="showNotPlanned"></v-switch>
    nicht-eingetragene
    <ReportButton
      color="success"
      text
      resource="report/exams"
      :parameters="{ type: 'person', id: personId }"
      >XLS</ReportButton
    >
    <v-btn
      color="info"
      text
      :to="{ name: 'ICalendar' }"
      v-if="personId == $_profilePerson.id"
      ><v-icon left>mdi-calendar-sync</v-icon>ical</v-btn
    >
  </Calendar>
</template>
<script>
import { defineComponent } from "vue";
import Calendar from "@/components/Calendar.vue";
import ReportButton from "@/components/ReportButton.vue";

export default defineComponent({
  name: "Register",
  components: { Calendar, ReportButton },
  props: ["person"],
  data() {
    return {
      loading: false,
      exams: [],
      holidays: [],
      showNotPlanned: true,
    };
  },
  computed: {
    personId() {
      return this.person ? this.person.id : -1;
    },
    examsFiltered() {
      return this.exams.filter((el) => this.showNotPlanned || el.plannedExam);
    },
  },
  methods: {
    async fetchData(start, end) {
      if (!this.person) return;

      this.loading = true;
      this.holidays = await this.apiList({
        resource: "common/holiday",
        query: `startDate=${start}&endDate=${end}`,
      });
      this.exams = await this.apiList({
        resource: "register/note",
        query: `person=${this.person.id}&type=exam&startDate=${start}&endDate=${end}`,
      });

      this.loading = false;
    },
  },
});
</script>
